import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import  PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';

export default function PaginationControlled({onChange, pageNow, totalCount}) {
    const { authDataLang } = useAuth();
    const handleChange = (event, value) => {
        onChange(value);
    };
    

  return (
    <Stack spacing={2} dir={authDataLang?.view_sts ? "ltr" : "rtl"}>
      <Pagination 
            color="primary" 
            count={totalCount} 
            page={pageNow} 
            onChange={handleChange} />
    </Stack>
  );
}


PaginationControlled.propTypes = {
    onChange: PropTypes.func.isRequired,
    pageNow: PropTypes.number.isRequired,
};
